<script setup>
import { computed, getCurrentInstance } from 'vue'

// Component properties specification contract
const props = defineProps({
    reportsModule: {
        type: Object,
        required: true,
        default: () => ({})
    }
})

// Extract route proxy context natively inside the compilation setup macro phase
const { proxy } = getCurrentInstance()

// Reactive data bindings mapping directly to parent state managers
const formData = computed(() => props.reportsModule?.formData || {})
const reports = computed(() => props.reportsModule?.reports || [])

// Initialization logic replaces the options-api 'created' phase
const reportName = proxy.$route?.query?.reportName || ''

if (formData.value) {
    // Vue 2.7 reactive layout fallback utilizing standard proxy tracking wrapper
    proxy.$set(formData.value, 'reportName', reportName)
}
</script>

<template>
    <select v-model="formData.reportName" class="form-select form-select-sm" name="reportName">
        <option value="" selected disabled>Select a report&hellip;</option>
        <option v-for="report in reports" :key="report.name" :value="report.name">
            {{ report.label }}
        </option>
    </select>
</template>